/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-inquiry': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(6 6)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M18.908 12.094L16.56 7.739a1.515 1.515 0 00-1.328-.812h-1.774a.792.792 0 000 1.583h1.59c.073 0 .14.04.175.104l1.717 3.167a.198.198 0 01-.174.292h-2.912a1.187 1.187 0 00-1.187 1.187c0 .656-.532 1.188-1.188 1.188H7.521a1.188 1.188 0 01-1.188-1.188c0-.655-.531-1.187-1.187-1.187h-2.93a.198.198 0 01-.174-.29l1.65-3.166a.198.198 0 01.174-.107h1.28a.792.792 0 100-1.583H3.749a1.51 1.51 0 00-1.325.812L.097 12.093a1.076 1.076 0 00-.097.376v4.75c0 .656.532 1.187 1.188 1.187h16.625c.655 0 1.187-.531 1.187-1.187v-4.75a.956.956 0 00-.092-.375z"/><path pid="1" d="M6.85 5.898L9.025 8.8a.594.594 0 00.95 0l2.18-2.902a.593.593 0 00-.476-.95h-.791a.198.198 0 01-.2-.198V1.781a1.188 1.188 0 00-2.376 0V4.75c0 .11-.088.198-.197.198h-.792a.594.594 0 00-.475.95h.002z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-inquiry.js